import APIService from '@/services/APIService.js';

export default {

  getValidacoes(includeExpiredRecords) {
    return APIService.apiCall().get(`/validacaoBaixas/getValidacoes/${includeExpiredRecords}`);
  },

  salvarValidacaoBaixas(postData) {
    return APIService.apiCall().post(`/validacaoBaixas/salvar`, JSON.stringify(postData));
  },

  excluirValidacaoBaixas(id) {
    return APIService.apiCall().get(`/validacaoBaixas/excluir/${id}`);
  },

  executarValidacaoBaixas(id) {
    return APIService.apiCall().get(`/validacaoBaixas/executar/${id}`);
  },

  download(id, config = {}) {
    return APIService.apiCall().get(`/validacaoBaixas/baixarPlanilha/${id}`, { responseType: 'blob', ...config });
  }
};
